const typography = {
  fonts: {
    body: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    heading: `"p22-mackinac-pro", 'Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'`,
    mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
  },

  fontSizes: {
    '3xs': `${8 / 16}rem`,
    '2xs': `${10 / 16}rem`,
    xs: `${12 / 16}rem`,
    sm: `${14 / 16}rem`,
    md: `${16 / 16}rem`,
    lg: `${20 / 16}rem`,
    xl: `${24 / 16}rem`,
    '2xl': `${32 / 16}rem`,
    '3xl': `${40 / 16}rem`,
    '4xl': `${48 / 16}rem`,
    '5xl': `${64 / 16}rem`,
  },

  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    17: '4.5rem',
  },
};

export default typography;
